import DeliveredOrders from '../../../Components/Order/DeliveredOrder';

const DeliveredOrderList = () => {
  return (
    <div>
      <DeliveredOrders />
      {/* Additional NewOrder-specific UI */}
    </div>
  );
};

export default DeliveredOrderList;
